import React, { useMemo } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

// 🔥 helper
const getCssVar = (variable: string) => {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(variable)
    .trim();
};

const UserBarChart = ({ data }: any) => {
  // ✅ dynamic data
  const chartData = useMemo(
    () => [
      { name: "Users", value: data?.users || 0 },
      { name: "Bookings", value: data?.bookings || 0 },
      { name: "In-Progress", value: data?.in_progress || 0 },
      { name: "Completed", value: data?.completed || 0 },
    ],
    [data]
  );

  // ✅ colors
  const colors = useMemo(
    () => [
      getCssVar("--primary-main"),
      getCssVar("--blue"),
      getCssVar("--warning"),
      getCssVar("--success"),
    ],
    []
  );

  return (
    <ResponsiveContainer width="100%" height={250}>
      <BarChart data={chartData}>
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />

        <Bar dataKey="value" radius={[6, 6, 0, 0]}>
          {chartData.map((entry, index) => (
            <Cell key={index} fill={colors[index]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default UserBarChart;